export const DEFAULT_OUTER_WRAPPER_SIZE = 100
export const DEFAULT_INNER_WRAPPER_SIZE = 100
export const DEFAULT_SINGLE_PICTURE_SIZE = 100
export const DEFAULT_MULTIPLE_PICTURE_SIZE = 50
export const DEFAULT_MAX_NUMBER_OF_USERS = 3

export const DEFAULT_OUTER_WRAPPER_SIZE_MOBILE = 90
export const DEFAULT_SINGLE_PICTURE_SIZE_MOBILE = 50
export const DEFAULT_MULTIPLE_PICTURE_SIZE_MOBILE = 50

export const EXPANDED_OFFSET_TWO_PROFILES = 50
export const EXPANDED_OFFSET_THREE_PROFILES = 25
export const OFFSET_TWO_PROFILES = 30

export const OUTER_WRAPPER_SIZE = (isMobile) => (isMobile ? DEFAULT_OUTER_WRAPPER_SIZE_MOBILE : DEFAULT_OUTER_WRAPPER_SIZE)
export const SINGLE_PICTURE_SIZE = (isMobile) => (isMobile ? DEFAULT_SINGLE_PICTURE_SIZE_MOBILE : DEFAULT_SINGLE_PICTURE_SIZE)
export const MULTIPLE_PICTURE_SIZE = (isMobile) => (isMobile ? DEFAULT_MULTIPLE_PICTURE_SIZE_MOBILE : DEFAULT_MULTIPLE_PICTURE_SIZE)
